import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { GameProfile, Menu, ProfileCtx } from "./types";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.console, commonMenuItems.logs);
  return menu;
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  // BeamMP serves its server info on the game port and has no RCON
  statusPageConfig: {
    ...defaultProfile().statusPageConfig,
    showQueryPort: false,
    showRconPort: false,
  },
});
